import React, { useEffect, useState } from "react";
import {
  imgStyle,
  sizeStyle,
  sizeTextStyle,
  typeStyle,
  typeTextStyle,
  monthlyStyle,
  monthlyTextStyle,
  cashStyle,
  cashTextStyle,
  lotStyle,
  lotTextStyle,
  itemStyle,
  itemTextStyle,
  typeSmallTextStyle,
  typeSmallStyle,
  cookItemTextStyle,
  cookBigItemTextStyle,
  coopCashPriceStyle,
  coopCashPriceTextStyle,
  dateStyle,
  dateTextStyle,
} from "../styles/BuildingStyleSheet";
import LotDataService from "../services/lot.services";
import { determineTypeDisplayName } from "../util/items";

function currencyFormat(num) {
  return num?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export const BuildingSignForm = React.forwardRef((props, ref) => {
  const getPageMargins = () => {
    return `
    @page {
        margin: 0px !important;
        * {
           page-break-inside: avoid;
        }
       
    } 
    @media print {
        @page {
            size: landscape !important;
            page-break-inside: avoid;
        }
    }`;
  };

  const [type, setType] = useState("");
  const [qrCode, setQRCode] = useState("");
  const [formStyle, setFormStyle] = useState(
    require("../images/Leonard-Building-Sign.png")
  );

  const getRegionId = (state, lotNumber) => {
    // TEMPLATE: 001102
    let stateCode = state;
    let storeNumber = lotNumber;

    return `${stateCode}${storeNumber}`;
  };

  const fetchQrCode = async () => {
    const regionId = getRegionId(props.state, props.lot);

    if (qrCode) {
      let url = decodeURIComponent(qrCode);
      let params = new URLSearchParams(url);
      let sku = params.get("sku");
      let region = params.get("region_id");

      if (sku === props.itemName && region === regionId) {
        console.log("QR code already exists, skipping...");
        return;
      }
    }

    try {
      console.log("Fetching QR code...");

      const response = await LotDataService.generateQRCodeURL(
        props.brand,
        props.lot,
        regionId,
        props.itemName,
        props?.msrp
          ?.toString()
          ?.replace(",", "")
          ?.replace("$", "")
          ?.split(".")[0],
        props.type,
        props.buildingType
      );

      console.log("QR code response:", decodeURIComponent(response.url));

      setQRCode(response.url);
    } catch (error) {
      console.log("Error fetching QR code:", error);
    }
  };

  useEffect(() => {
    if (!props.itemName) return;

    const floorPlanNumber = props.itemName.split("-")[3] || "";
    const displayName = determineTypeDisplayName(
      props.itemName,
      floorPlanNumber
    );
    setType(displayName === "Pet" ? "Pet" : displayName);
  }, [props.itemName]);

  useEffect(() => {
    if (!type || !props.company) return;

    console.log("Setting style image, type:", type, "company:", props.company);

    let styleImage;
    if (props.company === "Cook") {
      if (
        type === "Planter" ||
        type === "Pet" ||
        (props.itemName && props.itemName.includes("PLANTER")) ||
        type === "Coop"
      ) {
        styleImage = require("../images/Cook-Blank-Simple-Sign-Form-Pet-Houses.png");
      } else {
        styleImage = require("../images/Cook-Building-Sign.png");
      }
    } else {
      if (
        props.itemName.startsWith("B-") &&
        type !== "Coop" &&
        !type.startsWith("Pet")
      ) {
        styleImage = require("../images/Leonard-Building-Sign.png");
      } else if (type === "Coop") {
        styleImage = require("../images/Leonard-Chicken-Coop-Sign.png");
      } else if (type === "Pet" || type === "Pet House") {
        styleImage = require("../images/Simple-Sign-Form-Pet-Houses.png");
      } else if (
        type === "Planter" ||
        (props.itemName && props.itemName.includes("PLANTER"))
      ) {
        styleImage = require("../images/Simple-Sign-Form-Planter.png");
      } else {
        const itemNamePart = props.itemName ? props.itemName.split("-")[1] : "";
        const cookBuildings = [
          "BARN",
          "UTLY",
          "GRDN",
          "TOOL",
          "HNDY",
          "BGAR",
          "UGAR",
          "SLIM",
        ];
        const leonardCookStyle = cookBuildings.includes(itemNamePart);

        if (props.company !== "Cook" && leonardCookStyle) {
          styleImage = require("../images/Cook-Building-Leonard-Sign.png");
        }
      }
    }

    // if (!styleImage) {
    //   styleImage =
    //     props.company === "Cook"
    //       ? require("../images/Cook-Building-Leonard-Sign.png")
    //       : require("../images/Leonard-Building-Sign.png");
    // }

    setFormStyle(styleImage);
    console.log("Form style:", styleImage);
  }, [type, props.company, props.itemName]);

  function getForm() {
    if (props.formType === "everything") {
      return (
        <>
          <style>{getPageMargins()}</style>
          <div
            ref={ref}
            className="print-form"
            style={{
              margin: "15px",
              fontFamily: "Arial, sans-serif",
              whiteSpace: "nowrap",
            }}
          >
            <img
              // src={require("../images/blank-bob-simple-sign.png")}
              src={formStyle}
              alt="Building Simple Sign"
              style={imgStyle}
            />
            <div className="size" style={sizeStyle}>
              <p style={sizeTextStyle}>{props.size}</p>
            </div>

            {/* Building Type Display if not a Coop  or a Pet House */}
            {type !== "Coop" && type !== "Planter" && type !== "Pet" && (
              <div
                className="type"
                style={
                  type.length >= 13 || type.toLowerCase().includes("premium")
                    ? typeSmallStyle
                    : typeStyle
                }
              >
                <h2
                  style={
                    type.length >= 13 || type.toLowerCase().includes("premium")
                      ? typeSmallTextStyle
                      : typeTextStyle
                  }
                >
                  {type}
                </h2>
              </div>
            )}

            {/* Monthly Price Display if not a Coop or Pet House */}
            {type !== "Coop" && type !== "Pet" && type !== "Planter" && (
              <div className="monthly" style={monthlyStyle}>
                <h3 style={monthlyTextStyle}>{props.monthly}</h3>
              </div>
            )}

            {/* Coop Cash Display */}
            {type === "Coop" && (
              <div className="coopCashPrice" style={coopCashPriceStyle}>
                <h3 style={coopCashPriceTextStyle}>
                  {currencyFormat(props.cashPrice.toString())}
                </h3>
              </div>
            )}

            {/* Pet House Cash Display */}
            {type === "Pet" && (
              <div className="coopCashPrice" style={coopCashPriceStyle}>
                <h3 style={coopCashPriceTextStyle}>
                  {currencyFormat(props.cashPrice.toString())}
                </h3>
              </div>
            )}

            {/* Planter Cash Display */}
            {type === "Planter" && (
              <div className="coopCashPrice" style={coopCashPriceStyle}>
                <h3 style={coopCashPriceTextStyle}>
                  {props.company === "Cook" &&
                    currencyFormat(props.cardPrice.toString())}
                  {props.company !== "Cook" &&
                    currencyFormat(props.cardPrice.toString())}
                </h3>
              </div>
            )}

            {/* MSRP and Card Price if not a Cook building, Coop, or Pet House */}
            {props.company !== "Cook" &&
              type !== "Coop" &&
              type !== "Pet" &&
              type !== "Planter" && (
                <>
                  {/* <div className="msrp" style={msrpStyle}>
                  <p style={msrpTextStyle}>${props.msrp.replace("$", "")}</p>
                </div> */}
                  {/* <div className="cardPrice" style={cardStyle}>
                  <p style={cardTextStyle}>
                    $
                    {props.cardPrice
                      .toString()
                      .replace("$", "")
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                  </p>
                </div> */}
                </>
              )}

            {/* {type === "Coop" && (
              <div className="msrp" style={coopMsrpStyle}>
                <p style={coopMsrpTextStyle}>
                  $
                  {currencyFormat(
                    props.msrp
                      .toString()
                      .replace("$", "")
                      .replace(/[^0-9\.-]+/g, "")
                  )}
                </p>
              </div>
            )} */}

            {/* {type === "Pet" && (
              <div className="msrp" style={coopMsrpStyle}>
                <p style={coopMsrpTextStyle}>
                  ${currencyFormat(props.msrp.toString().replace("$", ""))}
                </p>
              </div>
            )} */}

            {/* Cash Price Display if it's not a Coop or Pet House */}
            {type !== "Coop" && type !== "Pet" && type !== "Planter" && (
              <div className="cashPrice" style={cashStyle}>
                <p style={cashTextStyle}>
                  $
                  {props.company !== "Cook"
                    ? currencyFormat(
                        props.cashPrice?.toString()?.replace("$", "")
                      )
                    : currencyFormat(props.msrp?.toString()?.replace("$", ""))}
                </p>
              </div>
            )}

            {/* Card Price Display for Coops */}
            {/* {type === "Coop" && (
              <div className="cashPrice" style={coopCardPriceStyle}>
                <p style={coopCardPriceTextStyle}>
                  $
                  {props.company !== "Cook"
                    ? currencyFormat(
                        props.cardPrice.toString().replace("$", "")
                      )
                    : currencyFormat(props.cardPrice.toString())}
                </p>
              </div>
            )} */}

            {/* Card Price Display for Pet House */}
            {/* {type === "Pet" && (
              <div className="cashPrice" style={coopCardPriceStyle}>
                <p style={coopCardPriceTextStyle}>
                  $
                  {props.company !== "Cook"
                    ? currencyFormat(
                        props.cardPrice.toString().replace("$", "")
                      )
                    : currencyFormat(props.cardPrice.toString())}
                </p>
              </div>
            )} */}

            {/* Displays Lot Text if not a Cook building */}
            {props.lot !== "Cook" &&
              type !== "Coop" &&
              type !== "Pet" &&
              type !== "Planter" && (
                <div className="lotText" style={lotStyle}>
                  <p style={lotTextStyle}>{props.lot}</p>
                </div>
              )}

            {type === "Coop" && (
              <div
                style={{
                  position: "absolute",
                  top: "664px",
                  left: "35%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={lotTextStyle}>{props.lot}</p>
              </div>
            )}

            {type === "Pet" && (
              <div
                style={{
                  position: "absolute",
                  top: "656px",
                  left: "35%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={lotTextStyle}>{props.lot}</p>
              </div>
            )}

            {type === "Planter" && (
              <div
                style={{
                  position: "absolute",
                  top: "656px",
                  left: "35%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={lotTextStyle}>{props.lot}</p>
              </div>
            )}

            {/* Model Text */}
            {type !== "Coop" && type !== "Pet" && type !== "Planter" && (
              <div className="modelText" style={itemStyle}>
                <p
                  style={
                    props.company === "Cook"
                      ? props.itemName.length > 18
                        ? cookBigItemTextStyle
                        : cookItemTextStyle
                      : itemTextStyle
                  }
                >
                  {props.itemName}
                </p>
              </div>
            )}

            {(type === "Coop" || type === "Pet" || type === "Planter") && (
              <div
                className="modelText"
                style={{
                  position: "absolute",
                  top: "661px",
                  left: "58%",
                  textAlign: "left",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                >
                  {props.itemName}
                </p>
              </div>
            )}

            {props.company !== "Cook" && (
              <div className="dateStyle" style={dateStyle}>
                <p style={dateTextStyle}>{new Date()?.toLocaleDateString()}</p>
              </div>
            )}
          </div>
        </>
      );
    }

    if (props.formType === "priceonly") {
      fetchQrCode();

      return (
        <>
          <div style={{ height: "100%", margin: "0" }}>
            <style>{getPageMargins()}</style>
            <div
              ref={ref}
              style={{
                height: "100%",
                padding: "0",
                margin: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <div style={{ width: "auto" }}>
                <h5
                  style={{
                    fontSize: "325px",
                    fontWeight: "bold",
                    margin: "0",
                    transform: "scale(1, 1.5)",
                  }}
                >
                  <span style={{ fontSize: "75px", verticalAlign: "175%" }}>
                    $
                  </span>
                  {props.monthly}
                  <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                    /m
                  </span>
                </h5>

                {qrCode && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "50px",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={qrCode}
                        alt="QR Code"
                        height={"auto"}
                        width={"250px"}
                      />
                      <div
                        style={{
                          position: "absolute",
                          left: "100%", // positions the div to the right of the QR code
                          top: "50%",
                          transform: "translateY(-50%)", // centers the div vertically relative to the QR code
                          marginLeft: "20px",
                          whiteSpace: "nowrap",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          SCAN HERE
                        </span>
                        <span
                          style={{
                            display: "block",
                            marginTop: "5px",
                            fontSize: "50px",
                          }}
                        >
                          ←
                        </span>
                        <span
                          style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                        >
                          FOR ASSISTANCE
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {/*
                CENTERED QR CODE + TEXT, ORIGINAL DESIGN
                <span
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                        }}
                      >
                        SCAN HERE
                      </span>
                      <span
                        style={{
                          display: "block",
                          marginTop: "5px",
                          fontSize: "50px",
                        }}
                      >
                        →
                      </span>
                      <span
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                        }}
                      >
                        FOR ASSISTANCE
                      </span>
                    </div> */}

                {/*
                CENTERED QR CODE + TEXT ON BOTH SIDES
                <span
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                        }}
                      >
                        SCAN HERE
                      </span>
                      <span
                        style={{
                          display: "block",
                          marginTop: "5px",
                          fontSize: "50px",
                        }}
                      >
                        →
                      </span>
                      <span
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                        }}
                      >
                        FOR ASSISTANCE
                      </span>
                    </div> */}

                {/* 
                  CENTERED QR
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "50px",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={qrCode}
                        alt="QR Code"
                        height={"auto"}
                        width={"250px"}
                      />
                      <div
                        style={{
                          position: "absolute",
                          left: "100%", // positions the div to the right of the QR code
                          top: "50%",
                          transform: "translateY(-50%)", // centers the div vertically relative to the QR code
                          marginLeft: "20px",
                          whiteSpace: "nowrap",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          SCAN HERE
                        </span>
                        <span
                          style={{
                            display: "block",
                            marginTop: "5px",
                            fontSize: "50px",
                          }}
                        >
                          ←
                        </span>
                        <span
                          style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                        >
                          FOR ASSISTANCE
                        </span>
                      </div>
                    </div>
                  </div> */}

                <p
                  style={{
                    margin: "0",
                    fontSize: "15px",
                    position: "absolute",
                    top: "92vh",
                    left: "30px",
                  }}
                >
                  {props.itemName} - {props.lot}
                </p>
                <p
                  style={{
                    margin: "0",
                    fontSize: "15px",
                    position: "absolute",
                    top: "95vh",
                    left: "30px",
                  }}
                >
                  {new Date()?.toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </>
      );
    }

    if (props.formType === "sizeonly") {
      return (
        <>
          <style>{getPageMargins()}</style>
          <div
            ref={ref}
            className="print-form"
            style={{
              display: "flex",
              minHeight: "100vh",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <h5
              style={{
                margin: "auto",
                fontSize: "180px",
                fontWeight: "bold",
                width: "100%",
                border: "7px solid black",
                borderRadius: "35px",
                transform:
                  props.size.length > 7
                    ? "rotate(90deg) scaleY(1.5) translateY(80px) translateX(-20px)"
                    : "rotate(90deg) scaleY(1.5)",
                flex: "1",
                whiteSpace: "nowrap",
                padding: "10px",
              }}
            >
              {props.size.startsWith("8") ? (
                <>
                  <span style={{ color: "white", fontSize: "81px" }}>0</span>
                  {props.size}
                  <span style={{ color: "white", fontSize: "81px" }}>0</span>
                </>
              ) : (
                <>{props.size}</>
              )}
            </h5>
            <h5
              style={{
                margin: "auto",
                fontSize: "180px",
                fontWeight: "bold",
                width: "100%",
                border: "7px solid black",
                borderRadius: "35px",
                transform:
                  props.size.length > 7
                    ? "rotate(-90deg) scaleY(1.5) translateY(-180px) translateX(20px)"
                    : "rotate(-90deg) scaleY(1.5) translateY(-20px)",
                flex: "1",
                whiteSpace: "nowrap",
                padding: "10px",
              }}
            >
              {props.size.startsWith("8") ? (
                <>
                  <span style={{ color: "white", fontSize: "81px" }}>0</span>
                  {props.size}
                  <span style={{ color: "white", fontSize: "81px" }}>0</span>
                </>
              ) : (
                <>{props.size}</>
              )}
            </h5>
          </div>
        </>
      );
    }
  }

  return getForm();
});

export default BuildingSignForm;
